export default "__VITE_ASSET__0Wday5qi__"